import { useEffect } from 'react';
import './ifs.css'
import Navbar from '../Components/navbar'
import Footer from '../Components/Footer';
import cata1 from '../images/cata.png'
export default function Cata() {
  
  useEffect(() => {
       window.scrollTo(0, 0); 
     }, []);

  
  
  return (
         <>
                            
                            <Navbar/>
                            
                          
                            
                        
                        
                            
                            <section id="product" style={{ padding: '10px' }}>
                             <center>
  <div className="product-card" style={{ width: "50%" }}>
    <img src={cata1} alt="Graphics Card" className='img-fluid' id="spt" style={{ width: "250px", height: "250px" }} />
    <center>
      <a
        href="/catalog.pdf" // path relative to `public` folder
        download
        style={{
          display: "inline-block",
          marginTop: "10px",
          padding: "10px 20px",
          backgroundColor: "#0a1a36",
          color: "#fff",
          textDecoration: "none",
          borderRadius: "5px",
          fontFamily: "Poppins, sans-serif"
        }}
      >
        Download
      </a>
      <p>View Our Catalog</p>
    </center>
  </div>
</center>

                            </section>
                            
                            <Footer/>
                            </>
  )
}
